import CityPageToldos from "../components/CityPageToldos";

export default function ToldosMalaga() {
  return (
    <CityPageToldos
      name="Málaga"
      slug="malaga"
      cp="29001-29018"
      poblacion={597173}
      zonaGeo="Capital de la Costa del Sol"
      lat={36.7213}
      lng={-4.4214}
      zonas={["Centro Histórico", "Carretera de Cádiz", "El Palo", "Pedregalejo", "Teatinos", "Huelin", "La Luz", "Ciudad Jardín"]}
      landmarks={["Catedral", "Muelle Uno", "Castillo de Gibralfaro"]}
      municipiosLimitrofes={["Torremolinos", "Cártama", "Rincón de la Victoria"]}
      festivalLocal="Feria de Málaga, segunda semana de agosto"
      contextoTipologico="Áticos en Carretera de Cádiz con grandes terrazas, restaurantes Muelle Uno con toldos comerciales, viviendas costeras con salitre intenso."
      isCoreZone={true}
    />
  );
}